const cookie = require('cookie_js');
const $popupCookie = $('.cookie');
const $popupclose = $popupCookie.find('.popup__close');
let cookieValue = cookie('cookies_policy');

$(function () {
	if (cookieValue !== 'true') {
		$popupCookie.show();
	}

	$(document).on('click', '.js-cookie__btn', function (e) {
		cookie.set({
			cookies_policy: true
		}, {
			domain: '.' + location.host,
			path: '/',
			expires: 365
		});
		$popupCookie.hide();
	});

	$(document).on('click', function (e) {
		if ($popupCookie.is(':visible') && !$popupCookie.is(e.target) && $popupCookie.has(e.target).length === 0) {
			$popupCookie.hide();
		}
	});

	$popupclose.on('click', function (e) {
		$popupCookie.hide();
	});
});



// WEBPACK FOOTER //
// ./frontend/components/popup/popup.js